import { IonSkeletonText } from '@ionic/react';
import classes from './style.module.scss';

const Loader = () => {
  return (
    <div className={classes.programTitleHead}>
      <IonSkeletonText animated className={classes.image} />
      <div
        className={classes.fuelingPlanInfoContainer}
        style={{ background: 'none' }}
      >
        <div
          className={classes.fuelingPlanCategory}
          style={{ backgroundColor: 'transparent', padding: 0 }}
        >
          <IonSkeletonText animated style={{ width: 100, height: 25 }} />
        </div>
        <div className={classes.fuelingPlanNameNotes}>
          <IonSkeletonText animated style={{ width: 150 }} />
        </div>
      </div>
    </div>
  );
};

export default Loader;
